var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconError48Filled = function SvgIconError48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.999 40.7A16.7 16.7 0 1 0 7.299 24a16.72 16.72 0 0 0 16.7 16.7Zm-1.7-25h3.4v10.5h-3.4V15.7Zm0 13.5h3.4v3h-3.4v-3Z",
    fill: "current"
  })));
};
export default SvgIconError48Filled;